/**
 * «Hoy» y «ahora» en Europe/Madrid, sea cual sea la zona del navegador (3/11, B3).
 *
 * El panel del técnico calculaba «hoy» con `new Date().toISOString()`, que es la fecha en UTC: entre
 * las 00:00 y la 01:00 de Madrid (las 02:00 en verano) «hoy» era AYER, y las citas de hoy salían en
 * «Próximas». Mismo criterio que el servidor (tzMadrid.ahoraEnMadrid). `ahora` es inyectable para
 * probarlo.
 */

const FECHA = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Madrid', year: 'numeric', month: '2-digit', day: '2-digit' });
const HORA = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Madrid', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });

/** 'YYYY-MM-DD' de Madrid. */
export const hoyEnMadrid = (ahora = new Date()) => FECHA.format(ahora);

/** { hoy: 'YYYY-MM-DD', hora: 'HH:MM' } de Madrid. */
export function ahoraEnMadrid(ahora = new Date()) {
  return { hoy: hoyEnMadrid(ahora), hora: HORA.format(ahora) };
}

const hhmm = (h) => (h ? String(h).slice(0, 5) : null);

/** ¿Ya empezó la cita (hora de Madrid)? El criterio del servidor para «no asistió». */
export function citaYaEmpezo(cita, ahora = new Date()) {
  if (!cita || !cita.fecha) return false;
  const { hoy, hora } = ahoraEnMadrid(ahora);
  return `${cita.fecha} ${hhmm(cita.hora_inicio) || '00:00'}` <= `${hoy} ${hora}`;
}

/** ¿Ya terminó la cita (su hora de fin, o la de inicio si no tiene)? */
export function citaYaTermino(cita, ahora = new Date()) {
  if (!cita || !cita.fecha) return false;
  const { hoy, hora } = ahoraEnMadrid(ahora);
  const fin = hhmm(cita.hora_fin) || hhmm(cita.hora_inicio) || '23:59';
  return `${cita.fecha} ${fin}` <= `${hoy} ${hora}`;
}
